<template>
  <div class="contentwrapper">
    <div class="content-dark">
      <h1>Track your order</h1>

      <div class="form-order">
        <div>
          <label for="OrderId">Order Id</label>
        </div>
        <div>
          <input type="number" v-model="orderId" name="OrderId" />
        </div>
        <div>
          <label for="BillingSurname">Billing Surname</label>
        </div>
        <div>
          <input type="text" v-model="billingSurname" name="BillingSurname" />
        </div>
        <div class="button-grid">
          <invisible-recaptcha
            :sitekey="reCaptchaKey"
            :callback="findOrder"
            class="button-default"
            type="button"
            id="do-something-btn"
          >
            Track
          </invisible-recaptcha>
        </div>
      </div>

      <div v-if="recapatchaFailed" class="validation-notice">
        <h1>Recapatcha Failure</h1>
        <p>Unforuntely to many tries have been blocked</p>
      </div>

      <div v-if="hasTriedSearch && !hasOrder" class="validation-notice">
        <h1>Order not found</h1>
        <p>These details do not match any in our system. The most common reasons are:</p>
        <ul>
          <li>Your order was from a different website</li>
          <li>There’s a mistake in the information entered</li>
        </ul>
        <b>Is your order definitely from magazine.co.uk?</b>
        <p>We can only track orders placed through magazine.co.uk. If your order was placed elsewhere, 
          please contact that site directly. For help finding contact details for a specific magazine, 
          use our A-Z title finder.
        </p>
        <p>If your order was from magazine.co.uk and you need help, please <b><a href="#" v-on:click="showOrderNotFoundMore = true">click here</a></b>.</p>

        <p v-if="showOrderNotFoundMore">Please contact us at enquiries@magazine.co.uk with as many details of your order 
            as you can supply (e.g. date, name, title, delivery address), and any questions,
            and we will be happy to assist.
        </p>

      </div>

      <div class="more-arrow">
        <img src="@/assets/down-arrow.png" />
        <img src="@/assets/down-arrow.png" />
      </div>
    </div>

    <div class="content-light">
      <h1>Help and FAQs</h1>
      <b>What do I do if I don’t have my order number?</b>
      <p>
        Your order number is on your confirmation email. If you have not received this, please check
        your email (or junk) for an email from no-reply@magazine.co.uk.
      </p>

      <b>I can’t find my order confirmation email?</b>
      <p>Please make sure that your order was placed on magazine.co.uk. Unfortunately we can’t track orders from other sites.</p>
      <p>If you ordered elsewhere, please contact that site directly. For help finding contact details for a specific magazine you can use our A-Z title finder. </p>
      <p>If your order was from magazine.co.uk and you can’t find your order number, please  <b><a href="#" v-on:click="showFaqMore = true">click here</a></b>.</p>

      <p v-if="showFaqMore">If you can not find your magazine.co.uk order confirmation 
          please contact us at enquiries@magazine.co.uk with as many details of
          your order as you can supply (e.g. date, name, title, delivery address),
          and any questions which you have, and we will be happy to assist.
      </p>

    </div>
  </div>
</template>

<script>
import InvisibleRecaptcha from "vue-invisible-recaptcha";

export default {
  name: "FindOrder",
  components: {
    "invisible-recaptcha": InvisibleRecaptcha
  },
  data() {
    return {
      orderId: "",
      billingSurname: "",
      hasTriedSearch: false,
      recapatchaFailed: false,
      hasOrder: false,
      reCaptchaKey: "6LcoOYAaAAAAABE_6PLvCEn58mIRVeydVOjHmMJr",
      showOrderNotFoundMore: false,
      showFaqMore: false,
      // reCaptchaKey: "6LfDI4AaAAAAACq8gvp7Y-U-QUDcfpqhod9T74Ce"
    };
  },
  methods: {
    findOrder(recapatchaValue) {
      console.log("recapatchaValue:");
      console.log(recapatchaValue);
      this.hasOrder = false;
      this.recapatchaFailed = false;
      this.hasTriedSearch = false;

      this.$store
        .dispatch("findOrder", {
          jmag_order_id: this.orderId,
          billing_lastname: this.billingSurname,
          recapatcha: recapatchaValue
        })
        .then(
          response => {
            this.hasTriedSearch = true;
            this.hasOrder = true;

            if (this.order_is_multi_cart)
              this.$router.push("/" + this.order_transaction_ref + "/order-multi");
            else this.$router.push("/" + this.order_transaction_ref + "/order-progress/0");
          },
          error => {
            this.hasOrder = false;
            if (error.response.status == 429) {
              //recapatcha failed
              this.recapatchaFailed = true;
            } else {
              this.hasTriedSearch = true;
            }
          }
        );
    }
  },
  computed: {
    order_transaction_ref() {
      return this.$store.state.orderResponse !== null
        ? this.$store.state.orderResponse.order.transaction_ref
        : null;
    },
    order_is_multi_cart() {
      return this.$store.state.orderResponse !== null
        ? this.$store.state.orderResponse.order.products.length > 1
        : false;
    }
  }
};
</script>

<style lang="scss">
.form-order {
  font-size: 14px;
  display: grid;
  grid-gap: 10px;
  grid-template-columns: auto auto;

  justify-content: center;
  align-content: center;
  margin-bottom: 50px;

  .button-grid {
    grid-column: span 2;
    text-align: right;
    justify-content: flex-end;

    button {
      margin: 0;
    }
  }

  > div {
    display: flex;
    align-items: center;
  }

  input {
    padding: 5px 10px;
  }
}

.validation-notice {
  max-width: 500px;
  margin: 0 20px;
  h1 {
    text-align: left;
  }
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
